
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/courses/[course_id]",
      function () {
        return require("private-next-pages/courses/[course_id].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/courses/[course_id]"])
      });
    }
  